export default __webpack_public_path__ + "static/media/IconMap.87a7157a.svg";